<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" @click="$emit('click')" class="edit-icon" :class="classList">
		<g fill="none" fill-rule="evenodd">
			<g fill-rule="nonzero">
				<g>
					<path d="M10.167 1.327L4.133 7.36c-.048.048-.082.108-.099.173l-.518 1.995c-.034.13.004.269.1.364.072.073.169.112.268.112.032 0 .064-.004.096-.012l1.994-.518c.066-.017.126-.052.174-.1l6.033-6.033 1.215-1.215c.149-.149.149-.39 0-.538L11.92.111C11.849.041 11.752 0 11.65 0c-.1 0-.197.04-.268.111l-1.215 1.215zM5.683 8.763l-1.268.33.33-1.268 5.691-5.692.938.939-5.69 5.691zM11.651.918l.938.939-.677.677-.938-.939.677-.677z" transform="translate(-214.000000, -328.000000) translate(214.000000, 328.000000)"/>
					<path d="M13.127 4.123c-.21 0-.38.17-.38.38V16.73H.812V2.182h7.042c.21 0 .38-.17.38-.38s-.17-.38-.38-.38H.43c-.21 0-.38.17-.38.38v15.307c0 .21.17.38.38.38h12.696c.21 0 .38-.17.38-.38V4.503c0-.21-.17-.38-.38-.38z" transform="translate(-214.000000, -328.000000) translate(214.000000, 328.000000)"/>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'edit-icon',
	props: ['color'],
	computed: {
		classList() {
			return [
				this.color ? `edit-icon-${this.color}` : '',
			];
		},
	},
};
</script>

<style lang="scss" scoped>
.edit-icon {
	& > g > g {
		fill: #5ED52B;
	}
}

.edit-icon-primary {
	& > g > g {
		fill: var(--app-color-primary);
	}
}

.edit-icon-secondary {
	& > g > g {
		fill: var(--app-color-secondary);
	}
}

.edit-icon-error {
	& > g > g {
		fill: var(--app-color-error);
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/icons/edit-icon.vue